export const sheetSharedStorageWorker = new SharedWorker(
  new URL('./worker/sheetSharedWorker.ts', import.meta.url),
  { type: 'module' }
);

sheetSharedStorageWorker.port.start();
